import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=fa95e0aa"
import script from "./Surveys.vue?vue&type=script&lang=js"
export * from "./Surveys.vue?vue&type=script&lang=js"
import style0 from "./Surveys.vue?vue&type=style&index=0&id=fa95e0aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports